import React, { useState, Fragment, useEffect, useRef } from 'react';

import VacancyFilter from '../../components/Filter/VacancyFilter';
import { Link, useLocation } from 'react-router-dom';

import VacancyTable from './VacancyTable';
import { useForm } from 'react-hook-form';

export const filterVacancy = [
  {
    label: 'Активные',
    value: 'active',
    params: {
      is_active: true,
      is_broadcast: true,
    },
    emptyText: 'Активный вакансий нет',
  },
  {
    label: 'На модерации',
    value: 'moderation',
    params: {
      is_active: true,
      is_verified: false,
    },
    emptyText: 'На модерации вакансий нет',
  },
  {
    label: 'Неактивные',
    value: 'inactive',
    params: {
      is_active: true,
      is_verified: true,
      is_broadcast: false,
    },
    emptyText: 'Неактивных вакансий нет',
  },
  {
    label: 'Удаленные',
    value: 'deleted',
    params: { is_active: false },
    emptyText: 'Удаленных вакансий нет',
  },
];
function VacancyIndex() {
  const { pathname } = useLocation();

  const form = useForm({
    defaultValues: {
      vacancy: [],
      isShowAction: false,
      tabState: filterVacancy[0],
    },
  });
  return (
    <div className="mx-auto flex flex-1 flex-col w-full max-w-[1163px]">
      <div className="w-full mt-6 p-2">
        <div className="flex flex-row justify-between gap-1">
          <p className="text-2xl font-medium">Вакансии</p>
          <p className="flex flex-wrap justify-center items-center">
            <Link to={`/createJob`}>
              <button type="button" className="text-center border rounded py-2 px-2 text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                {'Создать поиск и подбор'}
              </button>
            </Link>{' '}
            <Link to={`/create`}>
              <button type="button" className="text-center border rounded py-2 px-2 text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300 m-2">
                {'Создать вакансию'}
              </button>
            </Link>
          </p>
        </div>
      </div>
      <div className="w-full flex flex-col first:flex-row zero:justify-evenly">
        <VacancyTable isAll={true} form={form} filter={filterVacancy} />
        <div className="hidden justify-start w-[30%] first:flex zero:p-1 xs:p-4 flex-col">
          <VacancyFilter form={form} />
        </div>
      </div>
    </div>
  );
}

export default VacancyIndex;
